import { useTranslation } from "react-i18next";
import Header from "~/components/header/Header";
import Footer from "~/components/home/Footer";
import { FleetBannerSection } from "~/components/FleetBannerSection";
import { ProductCardFull } from "~/components/products/list/ProductCardFull";
import { HOME_FLEET_BANNER } from "~/data/fleet-banner";
import { PRODUCT_FAMILIES } from "~/data/products-list";

export const handle = { sitemap: { title: "Shop All Products" } };

// "Shop all products." — every product family and its purchasable items, linked from
// the "Shop All Products" buttons in the home products section and the nav.
export default function ProductsList() {
  const { t } = useTranslation("products");

  return (
    <>
      <title>{t("meta.title")}</title>
      <meta name="description" content={t("list.metaDescription")} />

      <Header variant="default" />
      {/* No wrapping <main> — root.tsx already provides the page's single <main> landmark. */}
      {/* Same section shape as the PDP sections: the section owns background and vertical
          padding, the inner .wrap owns width. Type sizes are Figma's Title/Sm, /Md and /XL. */}
      <section className="bg-white pt-10 lg:pt-16">
        <div className="wrap flex flex-col items-center md:items-start">
          <h1 className="font-display text-text-heading text-figma-titles-sm-size md:text-figma-titles-md-size lg:text-figma-titles-xl-size text-center leading-[1.15] font-extrabold md:text-left lg:leading-[1.1]">
            {t("list.heading")}
          </h1>
        </div>
      </section>
      <section className="bg-white py-8 md:py-12">
        <div className="wrap flex flex-col gap-6 md:gap-8">
          {PRODUCT_FAMILIES.map((family, index) => (
            <ProductCardFull key={family.id} family={family} priority={index < 2} />
          ))}
        </div>
      </section>
      <FleetBannerSection
        content={HOME_FLEET_BANNER}
        namespace="home"
        // The banner's own lg:py-7 would otherwise win over the md values, and its 2xl width
        // would stop lining up with the cards.
        className="pt-4 pb-8 md:pt-0 md:pb-12 lg:pt-0 lg:pb-12 2xl:max-w-[1184px]!"
        rowFromMd
      />
      <Footer />
    </>
  );
}
